/**
 * Catalogue des objets.
 *
 * Equilibrage: les ingredients bruts rendent peu (8 a 16 points de faim), les
 * plats cuisines rendent nettement plus (40 a 55), ce qui justifie le detour
 * par la cuisine d'une maison.
 */
import type { ItemDef, ItemId } from '../types/items.ts'

export const OBJETS: Record<ItemId, ItemDef> = {
  // ------------------------------------------------------ matieres premieres
  bois: {
    id: 'bois',
    nom: 'Bois',
    icone: '🪵',
    couleur: 0x8b5a2b,
    faim: 0,
    energie: 0,
    categorie: 'matiere',
  },
  pierre: {
    id: 'pierre',
    nom: 'Pierre',
    icone: '🪨',
    couleur: 0x8d8d94,
    faim: 0,
    energie: 0,
    categorie: 'matiere',
  },
  sable: {
    id: 'sable',
    nom: 'Sable',
    icone: '⏳',
    couleur: 0xe8cf86,
    faim: 0,
    energie: 0,
    categorie: 'matiere',
  },
  fibre: {
    id: 'fibre',
    nom: 'Fibre',
    icone: '🌾',
    couleur: 0xc9b26b,
    faim: 0,
    energie: 0,
    categorie: 'matiere',
  },
  glace: {
    id: 'glace',
    nom: 'Glace',
    icone: '🧊',
    couleur: 0xa8e4f5,
    faim: 0,
    energie: 0,
    categorie: 'matiere',
  },
  minerai: {
    id: 'minerai',
    nom: 'Minerai',
    icone: '💎',
    couleur: 0x6fd1c4,
    faim: 0,
    energie: 0,
    categorie: 'matiere',
  },
  feuille: {
    id: 'feuille',
    nom: 'Feuille',
    icone: '🍃',
    couleur: 0x4fae44,
    faim: 0,
    energie: 0,
    categorie: 'matiere',
  },

  // ------------------------------------------------------- nourriture brute
  fruit: {
    id: 'fruit',
    nom: 'Fruit',
    icone: '🍍',
    couleur: 0xf5b93a,
    faim: 12,
    energie: 2,
    categorie: 'nourriture',
  },
  baie: {
    id: 'baie',
    nom: 'Baie',
    icone: '🫐',
    couleur: 0x6a4fbf,
    faim: 8,
    energie: 1,
    categorie: 'nourriture',
  },
  noix_coco: {
    id: 'noix_coco',
    nom: 'Noix de coco',
    icone: '🥥',
    couleur: 0x9c6b3f,
    faim: 14,
    energie: 4,
    categorie: 'nourriture',
  },
  figue: {
    id: 'figue',
    nom: 'Figue de barbarie',
    icone: '🍇',
    couleur: 0xb0417a,
    faim: 10,
    energie: 2,
    categorie: 'nourriture',
  },
  poisson: {
    id: 'poisson',
    nom: 'Poisson',
    icone: '🐟',
    couleur: 0x4a9ad4,
    faim: 16,
    energie: 3,
    categorie: 'nourriture',
  },
  champignon: {
    id: 'champignon',
    nom: 'Champignon',
    icone: '🍄',
    couleur: 0xd05a4a,
    faim: 9,
    energie: 1,
    categorie: 'nourriture',
  },

  // ---------------------------------------------------- nourriture cuisinee
  soupe: {
    id: 'soupe',
    nom: 'Soupe aux petits fruits',
    icone: '🍲',
    couleur: 0xd8763a,
    faim: 40,
    energie: 8,
    categorie: 'nourriture',
  },
  tarte: {
    id: 'tarte',
    nom: 'Tarte aux baies',
    icone: '🥧',
    couleur: 0xe0a25c,
    faim: 55,
    energie: 10,
    categorie: 'nourriture',
  },
  brochette: {
    id: 'brochette',
    nom: 'Brochette de poisson',
    icone: '🍢',
    couleur: 0xb5713c,
    faim: 50,
    energie: 12,
    categorie: 'nourriture',
  },

  // ------------------------------------------------- gateries de la cabane
  beigne: {
    id: 'beigne',
    nom: 'Beigne',
    icone: '🍩',
    couleur: 0xef9ec4,
    faim: 22,
    energie: 6,
    categorie: 'nourriture',
  },
  creme_glacee: {
    id: 'creme_glacee',
    nom: 'Crème glacée',
    icone: '🍦',
    couleur: 0xfff0d2,
    faim: 18,
    energie: 10,
    categorie: 'nourriture',
  },

  // ---------------------------------------------------------------- fabrique
  fusee: {
    id: 'fusee',
    nom: 'Fusée',
    icone: '🎆',
    couleur: 0xff5f7a,
    faim: 0,
    energie: 0,
    categorie: 'objet',
  },
  gros_poisson: {
    id: 'gros_poisson',
    nom: 'Gros poisson',
    icone: '🐠',
    couleur: 0x3f8fbf,
    faim: 26,
    energie: 4,
    categorie: 'nourriture',
  },
  poisson_rare: {
    id: 'poisson_rare',
    nom: 'Poisson des glaces',
    icone: '🐡',
    couleur: 0x9fe3f5,
    faim: 34,
    energie: 10,
    categorie: 'nourriture',
  },
  // ------------------------------------------------------------------ outils
  canne: {
    id: 'canne',
    nom: 'Canne à pêche',
    icone: '🎣',
    couleur: 0xb98b4e,
    faim: 0,
    energie: 0,
    categorie: 'outil',
  },

  limonade: {
    id: 'limonade',
    nom: 'Limonade',
    icone: '🧃',
    couleur: 0xf7e05a,
    faim: 8,
    energie: 14,
    categorie: 'nourriture',
  },
}

export function objet(id: ItemId): ItemDef {
  return OBJETS[id]
}

export function estComestible(id: ItemId): boolean {
  const d = OBJETS[id]
  return d.faim > 0 || d.energie > 0
}
